import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { EnvService } from 'src/app/service/system/env-service';
import { MsAdalAngular6Service } from 'microsoft-adal-angular6';
import { AuthenticationService } from 'src/app/service/system/authentication.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  private _channelSubscription: Subscription;
  private _languageSubscription: Subscription;

  startDate: Date = new Date();
  maxDate: Date = new Date();
  showHideExportDiv: Boolean = false;

  language = {
    data: [{ value: 'en_us', label: 'English' }, { value: 'fr_ca', label: 'French' }],
    selectedLanguage: { value: 'en_us', label: 'English' },
  }

  channel = {
    data: [{ value: 'webchat', label: 'Webchat' }],
    selectedChannel: { value: 'webchat', label: 'Webchat' }
  }
  userApplications;
  appData = {
    data: this.authService.getUserApplications() ? this.authService.getUserApplications() : [],
    selectedApp: this.authService.getCurrentUserApplication() ? this.authService.getCurrentUserApplication() : null
  };
  constructor(public _apiService: ApiService,
    private datePipe: DatePipe,
    private env: EnvService,
    private adalSvc: MsAdalAngular6Service,
    private authService: AuthenticationService) {
    this.userApplications = this.adalSvc.userInfo && this.adalSvc.userInfo.profile.given_name;
  }

  ngOnInit(): void {
    this._channelSubscription = this._apiService.onChannelChanged.subscribe(channel => {
      this.channel.selectedChannel = channel;
    });

    this._languageSubscription = this._apiService.onLanguageChanged.subscribe(lang => {
      this.language.selectedLanguage = lang;
    });
  }

  // remove if not needed
  getApplicationData() {
    if (this.userApplications && !this.authService.getUserApplications()) {
      var app = this.userApplications.split(";");
      this._apiService.resolveApplicationsDetailse(app).subscribe(data => {
        
        this.appData.data = data;
        this.appData.selectedApp = data[0];
        this.authService.updateUserApplications(data);
        // window.location.reload();
      }, error => {

      })
    }
  }

  ngOnDestroy(): void {
    this._channelSubscription.unsubscribe();
    this._languageSubscription.unsubscribe();
  }


  onChannelChange(channel) {
    this.channel.selectedChannel = channel;
    this._apiService.changeChannel(channel);
  }

  onAppChange(app) {
    console.log("----", app);
    this.appData.selectedApp = app;
    this.authService.setUserApplication(JSON.stringify(app));
    window.location.reload();
  }


  onLanguageChange(lang) {
    this.language.selectedLanguage = lang;
    this._apiService.changeLanguage(lang);
  }

  showHideExport() {
    this.showHideExportDiv = !this.showHideExportDiv;
  }

  downloadFeedbackReport() {
    let date = this.datePipe.transform(this.startDate, "dd-MM-yyyy")
    var link = document.createElement("a");
    link.download = "Report.csv";
    link.href = this.env.webchat_feedbackFileURL + `feedback/download?date=${date}`;
    this.startDate = new Date();
    link.click();
    this.showHideExportDiv = !this.showHideExportDiv;
  }
}
